export const styles = {
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    position: 'relative',
    borderRadius: '8px',
    width: '640px',
    height: '360px',
    background: '#fff1e8',
    padding: '20px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#667085',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '10px',
  },
  title: {
    color: '#4BBFEF',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: '28px',
    lineHeight: '40px',
    marginBottom: '10px',
    marginTop: '5px',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    paddingLeft: '50px',
    paddingRight: '50px',
  },
  justificationText: {
    color: '#383838',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '10px',
  },
  footer: {
    paddingTop: '15px',
    display: 'flex',
    justifyContent: 'space-around',
    width: '50%',
  },
  errorMessage: {
    color: 'red',
    marginTop: '10px',
    fontSize: '14px',
  },
  emoji: {
    width: '72px',
    height: '72px',
    flexShrink: 0,
    marginBottom: '0px',
  },
  buttonNo: {
    background: '#ee3b5e',
    color: 'white',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 600,
    fontSize: '18px',
    textTransform: 'none',
    '&:hover': {
      background: '#c92f4d',
    },
  },
  buttonConfirm: {
    background: '#4bbfef',
    color: 'white',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 600,
    fontSize: '18px',
    textTransform: 'none',
    '&:hover': {
      background: '#3a9ec9',
    },
  },
};
